import { Box, Button, Grid, Stack, Typography } from '@mui/material';
import { count } from 'console';
import React, { FC, Fragment, useContext, useEffect, useState } from 'react';
import GameHeader from '../../Layout/Public/Apps/NumberRecognitionGame/GameHeader';
import { WidthFull } from '@mui/icons-material';
import ComboLetterRow from './ComboCharRow';
import { FIVE_LETTER_WORDS_LIST, gameConfig } from './game-config';
import {
  createRandomPairs,
  getRandomArray,
  getRandomStringFromArr,
} from '../../../Utils/StringUtils';
import WordInput from './WordInput';

// Define the interface for the component's props
interface UnlockWordgameProps {}

// Functional Component using props and state
const UnlockWordgame: FC<UnlockWordgameProps> = ({}) => {
  const gameChars = [
    'a',
    'b',
    'c',
    'd',
    'e',
    'f',
    'g',
    'h',
    'i',
    'j',
    'k',
    'l',
    'm',
    'n',
    'o',
    'p',
    'q',
    'r',
    's',
    't',
    'u',
    'v',
    'w',
    'x',
    'y',
    'z',
    '1',
    '2',
    '3',
    '4',
    '5',
  ];

  //   const clueOnlyChars = gameConfig.join('').split('');
  //   console.log('clueOnlyChars::: ', clueOnlyChars);

  const [playerTaps, setPlayerTaps] = useState(0);

  const [gameWord, setGameWord] = useState(
    getRandomStringFromArr(FIVE_LETTER_WORDS_LIST)
  );

  //   const chars = ['j', 'o', 'l', 'l', 'y'];
  //   const chars = getRandomStringFromArr(FIVE_LETTER_WORDS_LIST);
  const nums = ['1', '2', '3', '4', '5'];

  // const result = ;
  const [gameWordsPairs, setGameWordsPairs] = useState(
    createRandomPairs(gameWord, nums)
  );
  console.log('GAME WORD::: ', gameWord);
  console.log(gameWordsPairs);
  const clueOnlyChars = gameWordsPairs.join('').split('');
  console.log('clueOnlyChars::: ', clueOnlyChars);

  const onPlayerTapHandler = () => {
    setPlayerTaps((prev) => prev + 1);
  };

  const checkWordHandler = (word: string) => {
    console.log('word::: ', word);
    if (word.toLocaleLowerCase() === gameWord.toLocaleLowerCase()) {
      console.log('Player Wins!');
    } else {
      console.log('Keep trying!');
    }
  };

  return (
    <Box sx={(theme) => ({ height: '100%' })}>
      <Grid container direction="column">
        <Grid item xs={6} sx={{ textAlign: 'center', pt: '0px !important' }}>
          <GameHeader
          // count={count}
          // openHowToPlayModalHandler={openHowToPlayModalHandler}
          />
        </Grid>
      </Grid>
      <Stack
        direction="row"
        spacing={2}
        justifyContent="center"
        alignItems="center"
        sx={(theme) => ({ mt: -4, pb: 1 })}
      >
        {/* <Typography variant="h3">01:30</Typography> */}
        <Typography variant="h3">{playerTaps}</Typography>
      </Stack>
      <Stack
        direction="column"
        // spacing={8}
        justifyContent="space-between"
        alignItems="center"
        sx={(theme) => ({ flexGrow: 1, height: '80vh' })}
      >
        <Grid
          container
          justifyContent="center"
          alignItems="center"
          // style={{ border: '2px solid red' }}
          // sx={(theme) => ({ height: 500 })}
        >
          <Grid
            item
            xs={8}
            sm={4}
            md={3}
            lg={2}
            style={{
              // border: '1px solid blue',
              // width: 10,
              textAlign: 'center',
              // height: 500,
            }}
          >
            {/* Inner Boxes */}
            <Grid container direction="column" spacing={2}>
              {gameWordsPairs.map((charCombo, index) => (
                <Grid
                  item
                  xs={6} // Size of individual boxes
                  key={index}
                  display="flex"
                  justifyContent="center"
                  alignItems="center"
                  spacing={5}
                >
                  <ComboLetterRow
                    index={index}
                    charCombo={charCombo}
                    winningPairs={gameWordsPairs}
                    gameChars={clueOnlyChars}
                    onPlayerTapHandler={onPlayerTapHandler}
                  />
                </Grid>
              ))}
            </Grid>
          </Grid>
        </Grid>
        <Stack
          direction="column"
          spacing={2}
          justifyContent="center"
          alignItems="center"
          sx={(theme) => ({ mt: 2, mb: 2 })}
        >
          <WordInput checkWordHandler={checkWordHandler} />
        </Stack>
      </Stack>
    </Box>
  );
};

export default UnlockWordgame;
